const data = new Array(21).fill(0).map((el, index) => index)
export const SIZE_SELECTOR_DATA = data.map((el) => {
  return { id: `${el}`, label: `${el}px` }
})
